import SuperRepository from '../superRepository'

export default new (class ProjectsRepository extends SuperRepository {
  baseUri() {
    return 'project'
  }
  createFromTemplate =  async (id, data) => this.httpClient().post(`${this.baseUri()}/create_from_template/${id}`, data);
  createTemplate =  async (id, data) => this.httpClient().post(`${this.baseUri()}/create_template/${id}`, data);
})()
